// import React from "react";

// function SidebarItem({ id, label, selectedId, setSelectedId, icon: Icon, className = "" }) {
//   const isSelected = selectedId === id;

//   return (
//     <div
//       onClick={() => setSelectedId(id)}
//       className={`w-full flex items-center justify-between cursor-pointer transition-colors ${
//         isSelected ? "bg-[#305d4d]" : "hover:bg-[#406d5d]"
//       } ${className}`}  
//     >
//       <div className="flex items-center py-2 pl-20">
//         {Icon && <Icon className="text-[#7ABC32]" size={10} />}
//         <span className="ml-2 text-sm text-gray-300">{label}</span>
//       </div>
//       {isSelected && <div className="w-2 h-full bg-[#7ABC32]" />}
//     </div>
//   );
// }

// export default SidebarItem;
// import React from "react";

// function SidebarItem({ id, label, selectedId, setSelectedId, icon: Icon, className = "", iconClassName = "" }) {
//   const isSelected = selectedId === id;

//   return (
//     <div
//       onClick={() => setSelectedId(id)}
//       className={`w-full flex items-center justify-between cursor-pointer transition-colors ${
//         isSelected ? "bg-[#305d4d]" : "hover:bg-[#406d5d]"
//       } ${className}`}
//     >
//       <div className="flex items-center py-2 pl-20">
//         {Icon && <Icon className={`mr-2 ${iconClassName}`} size={14} />}
//         <span className="text-sm text-gray-300">{label}</span>
//       </div>
//       {isSelected && <div className="w-2 h-full bg-[#7ABC32]" />}
//     </div>
//   );
// }

// export default SidebarItem;
import React from "react";
import { Link } from "react-router-dom";

function SidebarItem({
  id,
  label,
  selectedId,
  setSelectedId,
  icon: Icon,
  className = "",
  iconClassName = "",
  labelClassName = "",
  to = "#", // route path
}) {
  const isSelected = selectedId === id;

  return (
    <Link
      to={to}
      onClick={() => setSelectedId(id)}
      className={`w-full flex items-center justify-between cursor-pointer transition-colors ${
        isSelected ? "bg-[#305d4d]" : ""
      } ${className}`}
    >
      <div className="flex items-center ml-8 py-2 pl-6 pr-3 w-full">
        {Icon && <Icon className={`mr-2 ${iconClassName}`} size={14} />}
        <span className="text-sm   ${labelClassName}">{label}</span>
      </div>
      {isSelected && <div className="w-2 h-full bg-[#7ABC32]" />}
    </Link>
  );
}

export default SidebarItem;
